import React from "react";
import HowWeHelp from "../components/HowWeHelp";
import BlogsHero from "../components/BlogsHero";
import BlogsData from "../components/BlogsData";

const BlogsPage = () => {
    return (
        <div>
            <BlogsHero />
            <BlogsData />
            <HowWeHelp />
        </div>
    );
};

export default BlogsPage;
